<template>
    <x-page title="Gatherings">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>
        <gathering-form id="gathering-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource" />
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import { formatForDateInput, handleGeneralXhrError } from '../../helpers'
import GatheringForm from './GatheringForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        GatheringForm,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/gatherings/${this.$route.params.id}`, {
                params: {
                    load: [
                        'attendants',
                    ],
                }
            })
            .then(response => {
                const resource = response.data.data
                this.resource = { 
                    ...resource,
                    date: formatForDateInput(resource.date),
                    member_ids: resource.attendants.map(attendant => attendant.id),
                }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
    },
}
</script>